var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isReadOnly && _vm.hasUserEmailAddress
        ? _c("InviteesListSearch", {
            attrs: { "already-invited-emails": _vm.alreadyInvitedEmails },
            on: { addAttendee: _vm.addAttendee }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasOrganizer
        ? _c("OrganizerListItem", {
            attrs: {
              "is-read-only": _vm.isReadOnly,
              organizer: _vm.calendarObjectInstance.organizer
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.inviteesWithoutOrganizer, function(invitee) {
        return _c("InviteesListItem", {
          key: invitee.email,
          attrs: {
            attendee: invitee,
            "is-read-only": _vm.isReadOnly,
            "organizer-display-name": _vm.organizerDisplayName
          },
          on: { removeAttendee: _vm.removeAttendee }
        })
      }),
      _vm._v(" "),
      _vm.isReadOnly && _vm.isListEmpty ? _c("NoInviteesView") : _vm._e(),
      _vm._v(" "),
      !_vm.isReadOnly && _vm.isListEmpty && _vm.hasUserEmailAddress
        ? _c("NoInviteesView")
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReadOnly && _vm.isListEmpty && !_vm.hasUserEmailAddress
        ? _c("OrganizerNoEmailError")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "invitees-list-button-group" },
        [
          _vm.isCreateTalkRoomButtonVisible
            ? _c(
                "button",
                {
                  attrs: { disabled: _vm.isCreateTalkRoomButtonDisabled },
                  on: { click: _vm.createTalkRoom }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t("calendar", "Create Talk room for this event")
                      ) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isReadOnly
            ? _c(
                "button",
                {
                  attrs: { disabled: _vm.isListEmpty },
                  on: { click: _vm.openFreeBusy }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("calendar", "Show busy times")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showFreeBusyModel
            ? _c("FreeBusy", {
                attrs: {
                  attendees: _vm.calendarObjectInstance.attendees,
                  organizer: _vm.calendarObjectInstance.organizer,
                  "start-date": _vm.calendarObjectInstance.startDate,
                  "end-date": _vm.calendarObjectInstance.endDate
                },
                on: { close: _vm.closeFreeBusy }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }